import auth from "../middlewares/auth"
import checkModification from "../middlewares/checkModification"
import router from "../routes"

const middlewares = [auth, checkModification]

router.beforeEach((to, from, next) => {
    for (let middleware of middlewares) {
        middleware.handle(to, from, next)
    }
})
